import React from "react";
import { Outlet } from "react-router-dom";
import SidebarSkeleton from "./SidebarSkeleton";
import ParentSkeleton from "./ParentSkeleton";
import Header from "../../components/Header";
import { useLoadingStore } from "../../contextApi/toggleLoader";
import Loader from "../../components/Loader";
const UserLayout = () => {

  const { loading } = useLoadingStore()
  return (
    <div className="userLayoutWrapper">
      <ParentSkeleton>
        {loading ? <Loader /> : <Outlet />}
      </ParentSkeleton>
    </div>
  );
};

export default UserLayout;
